export default "/static/empty/no-records.png"